import SubjectsPage from "../components/pages/Subjects";

export default SubjectsPage;
